import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var ClockSnooze = function ClockSnooze(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M16.5 17h5l-5 5h5m.4506-9q.0492-.4935.0494-1c0-5.5228-4.4772-10-10-10S2 6.4772 2 12s4.4772 10 10 10a10.1 10.1 0 0 0 1-.0494M12 6v6l3.7384 1.8692"
    })
  }));
};
export default ClockSnooze;